import Vue from 'vue'
import Vuex from 'vuex'
import convertMonth from '@/plugins/filters'
import auth from './auth'
import calendar from './calendar'
import dashboard from './dashboard'
import notevoc from './notevoc'
import checkinout from './checkinout'
import visit from './visit'
import visitShopDetail from './visitShopDetail'

Vue.use(Vuex)
Vue.filter('convertMonth', convertMonth)

export const state = () => ({
  title: '',
  loading: 0,
})

export const getters = {
  titlename(state) {
    return state.title
  },
}

export const mutations = {
  SET_TITLE(state, data) {
    state.title = data
  },
  loadingUpdate(state, data) {
    if (data) {
      state.loading = state.loading + 1
    } else {
      if (state.loading > 0) {
        state.loading = state.loading - 1
      }
    }
  },
}

export const actions = {
  setTitle({ commit }, data) {
    commit('SET_TITLE', data)
  },
}

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,

  modules: {
    auth,
    calendar,
    dashboard,
    notevoc,
    checkinout,
    visit,
    visitShopDetail,
  },
})
